export enum TipoNotificacao {
  TICKET_CRIADO = 'TICKET_CRIADO',
  TICKET_ATUALIZADO = 'TICKET_ATUALIZADO',
  TICKET_FECHADO = 'TICKET_FECHADO',
  TICKET_REABERTO = 'TICKET_REABERTO',
  TICKET_ATRIBUIDO = 'TICKET_ATRIBUIDO',
  COMENTARIO_ADICIONADO = 'COMENTARIO_ADICIONADO',
  ANEXO_ADICIONADO = 'ANEXO_ADICIONADO',
} 